export const ValidationMessages = {
    requiredField: "Campo obligatorio",
    invalidCharacters: "¡Carácteres invalidos!"
}